import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NortonProductCheckService {

  nortonProdValue: boolean;
  constructor() { }

  public checkForNortonName(nortonName: string) {
    this.nortonProdValue = nortonName === 'Norton Security 5';
    return this.nortonProdValue
  }
}
